// Lib
import React from 'react';
import { Helmet } from 'react-helmet-async';

// API
import { ORIGIN_URL } from '@api';

// Components
import ReactUI from './ReactUI';
import Popup from './Popup';
import Drawer from './Drawer';
import Toast from './Toast';
import AppSetup from './AppSetup';
import CustomDomainUI from './CustomDomainUI';
import RedirectLink from './RedirectLink';
import ErrorBoundary from './ErrorBoundary';
import WindowsScrollbars from './WindowsScrollbars';

interface AppProps {
  domain?: string;
}

const App: React.FC<AppProps> = ({ domain }) => {
  const hostname =
    typeof window === 'object' ? window?.location?.hostname : domain;
  const url =
    typeof window === 'object'
      ? window?.location?.href
      : domain
      ? `https://${domain}`
      : '';
  const isMainDomain = [
    'dev.mrbl.bio',
    'mrbl.bio',
    'ecommerce.mrbl.bio',
    'localhost',
  ]?.includes(hostname || '');

  const isRedirectLink =
    typeof window === 'object'
      ? window.location.pathname.startsWith('/l/')
      : false;

  return (
    <>
      {isRedirectLink ? null : isMainDomain ? <AppSetup /> : null}
      <WindowsScrollbars />
      <Helmet>
        <title>Marble</title>
        <meta property="og:url" content={isMainDomain ? ORIGIN_URL : url} />
        <meta property="og:title" content="Marble" />
        <meta property="twitter:title" content="Marble" />
        <meta
          property="og:image"
          content="https://static.mrbl.bio/frontend/mixed/splashV3.jpg"
        />
        <meta
          property="twitter:image"
          content="https://static.mrbl.bio/frontend/mixed/splashV3.jpg"
        />
      </Helmet>
      {isRedirectLink ? null : (
        <>
          <Popup />
          <Drawer />
        </>
      )}
      <ErrorBoundary>
        {isRedirectLink ? (
          <RedirectLink />
        ) : isMainDomain ? (
          <>
            <ReactUI />
            <Toast />
          </>
        ) : (
          <CustomDomainUI />
        )}
      </ErrorBoundary>
    </>
  );
};

export default App;
